import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { updateNetworkSetting } from "../../../services/table.services";
import { addRestData } from "../../../../../redux/slices/restSettings";

export default function NetworkSetting() {
  const { t } = useTranslation();
  const restSettingDetails = useSelector((state) => state?.restSettings?.data);
  const dispatch = useDispatch();
  
  const updateSetting = (networkType) => {
    updateNetworkSetting({network_setting_wifi: networkType}).then(() => {
      const updatedData = { ...restSettingDetails, network_setting_wifi: networkType };
      dispatch(addRestData(updatedData));
    });
  };

  return (
    <div>
      <div className="card-outer-header d-flex justify-content-between align-items-center">
        <h4 className="heading-title-text">{t("label_network_settings")}</h4>
      </div>

      <div className="dashboard-content-wraper mt-4">
        {/* LAN Option */}
        <div className="card mb-3">
          <div className="card-body">
            <div className="d-flex align-items-center justify-content-between">
              <h6 className="mb-0">{t("label_lan")}</h6>
              <div className="form-check form-switch">
                <input
                  className="form-check-input cp"
                  type="checkbox"
                  // checked={restSettingDetails?.network_setting === "lan"}
                  // onChange={() => updateSetting("lan")}
                  disabled
                />
              </div>
            </div>
          </div>
        </div>

        {/* WiFi Option */}
        <div className="card">
          <div className="card-body">
            <div className="d-flex align-items-center justify-content-between">
              <h6 className="mb-0">{t("label_wifi")}</h6>
              <div className="form-check form-switch">
                <input
                  className="form-check-input cp"
                  type="checkbox"
                  checked={restSettingDetails?.network_setting_wifi === true}
                  onChange={() => updateSetting(!restSettingDetails?.network_setting_wifi)}
                  // checked= {true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
